<template>
  <div class="login-wrapper">
    <div class="login-container">
      
      <!-- Login Section (Not Auth) -->
      <div class="login-card" v-if="!isAuth">
        <div class="logo-container">
          <img src="../assets/logo.png" class="logo-img" alt="Logo" />
        </div>
        <h1 class="benvenuto">{{ $t('login_welcome') }}</h1>
        
        <div class="input-group">
            <label>{{ $t('username') }}</label>
            <input type="text" v-model="googleMail"/>
        </div>
        
        <div class="input-group">
            <label>{{ $t('password_label') }}</label>
            <input type="password" v-model="password" @keyup.enter="getList" placeholder="••••••••"/>
        </div>
        
        <button class="primary-btn" @click="getList">
          {{ $t('login_button') }}
        </button>
      </div>

      <!-- Google Auth Section -->
      <div class="login-card" v-if="isAuth">
        <div class="logo-container">
          <img src="../assets/logo.png" class="logo-img" alt="Logo" />
        </div>
        <h1 class="benvenuto">{{ $t('login_welcome') }}</h1>
        <div class="path-info">{{store.path }}</div>
        
        <button class="primary-btn google-btn" @click="dataLog">
          <svg class="google-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg>
          {{ $t('google_login') }}
        </button>
      </div>

    </div>
  </div>
</template>

<script>
import { googleAuthCodeLogin } from "vue3-google-login"
import { store } from '../store/store.js'

export default {
  name: 'LoginAdmin',
  data: function () {
      return{
        nomeUtente : '',
        password: '',
        isAuth:false,
        googleMail:'',
        store
      }
  },
    methods: {
        getList() {
            this.axios.post(this.store.path+'login',{nome:this.googleMail, password:this.password}).then((response) => {
                localStorage.setItem( 'token', JSON.stringify(response.data.token) );
                this.store.reloadTok(response.data.token);
                localStorage.setItem( 'nome', JSON.stringify(response.data.nome) );
                this.$router.push({ name: "Gestionale", params :{data:`Ben Tornato ${this.nomeUtente}`,token: response.data.token} })
                console.log(response.data)
        })
        },
        dataLog (){
          googleAuthCodeLogin().then((response) => {
            console.log("Handle the response", response)
            this.infoUser(response)
        })

        },
        infoUser(userData) {
          this.axios.post('http://127.0.0.1:5000/login/google',{code:userData.code}).then((response) => {
            console.log(response.data.messaggio.email)
            if(response.data.messaggio.email){
              this.googleMail = response.data.messaggio.email;
              this.axios.post('http://127.0.0.1:5000/login/gest',{mail:this.googleMail}).then((response) => {
              console.log(response.data.messaggio)
              if(response.data.messaggio){
                console.log(response.data.path)
                this.store.reloadPath(response.data.path)
              }else{console.log('Non è stato possibile caricare il path')}
        })
              this.isAuth=true;
            }
          })
        },
    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

.login-wrapper {
  background: linear-gradient(135deg, #13151a 0%, #1c1f26 100%);
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  color: #ffffff;
  box-sizing: border-box;
}

.login-container {
  width: 100%;
  max-width: 440px;
  perspective: 1000px;
}

.login-card {
  background: rgba(30, 33, 41, 0.85);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 24px;
  padding: 48px 40px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: slideUp 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  opacity: 0;
  transform: translateY(30px);
}

@keyframes slideUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.logo-container {
  margin-bottom: 32px;
}

.logo-img {
  width: 180px;
  height: 180px;
  object-fit: cover;
  border-radius: 50%;
  border: 4px solid rgba(255, 255, 255, 0.05);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.4);
  background-color: #fff;
  padding: 6px;
  transition: transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.logo-img:hover {
  transform: scale(1.05) rotate(2deg);
}

.benvenuto {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 32px;
  text-align: center;
  background: linear-gradient(to right, #ffffff, #9ca3af);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  letter-spacing: -0.5px;
}

.input-group {
  width: 100%;
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.input-group label {
  font-size: 14px;
  font-weight: 500;
  color: #9ca3af;
  margin-bottom: 10px;
  padding-left: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.input-group input {
  width: 100%;
  background: rgba(15, 17, 21, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 14px;
  padding: 16px 20px;
  color: #ffffff;
  font-size: 16px;
  transition: all 0.3s ease;
  box-sizing: border-box;
  font-family: 'Inter', sans-serif;
}

.input-group input:focus {
  outline: none;
  border-color: #6366f1;
  background: rgba(15, 17, 21, 0.9);
  box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.2);
}

.input-group input::placeholder {
  color: #4b5563;
}

.input-group input:disabled {
  color: #6b7280;
  cursor: not-allowed;
  background: rgba(15, 17, 21, 0.4);
}

.primary-btn {
  width: 100%;
  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
  color: white;
  border: none;
  border-radius: 14px;
  padding: 16px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 16px;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  box-shadow: 0 6px 16px rgba(99, 102, 241, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  font-family: 'Inter', sans-serif;
}

.primary-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(99, 102, 241, 0.5);
  background: linear-gradient(135deg, #4f46e5 0%, #4338ca 100%);
}

.primary-btn:active {
  transform: translateY(0);
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.4);
}

.google-btn {
  background: #ffffff;
  color: #1f2937;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.google-btn:hover {
  background: #f9fafb;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
}

.google-icon {
  width: 22px;
  height: 22px;
}

.path-info {
  margin-bottom: 24px;
  color: #d1d5db;
  font-size: 14px;
  background: rgba(0, 0, 0, 0.3);
  padding: 12px 20px;
  border-radius: 12px;
  word-break: break-all;
  text-align: center;
  border: 1px solid rgba(255, 255, 255, 0.05);
}
</style>